import React from "react";
import PropTypes from 'prop-types';
import Button from "@material-ui/core/Button";
import MenuDesigner from "../../../../../../../../MenuDesignerNew";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(() => ({
    dialogRoot: {
        padding: 0
    },
    content: {
        padding: 0,
        '&:first-child': {
            padding: 0
        }
    }
}));

const OpenContextDesigner = (props) => {
    const {onOpen, onClose, isOpen, onSave, currentValues} = props;
    const classes = useStyles();
    return (
        <>
            <Button
                style={{textAlign: "center", marginTop: 10}}
                size={"small"}
                variant={"contained"}
                color={"primary"}
                onClick={onOpen}
                fullWidth
                id={"contextDesignerBtn"}
            >
                Open Context Editor
            </Button>
            {
                isOpen && (
                    <Dialog open={isOpen} onClose={onClose} maxWidth={"xl"}
                            classes={{root: classes.dialogRoot, paper: classes.dialogRoot}}>
                        <DialogContent classes={{root: classes.content}}>
                            <MenuDesigner
                                closePopup={onClose}
                                returnValue={onSave}
                                match={{params: {id: currentValues}}}
                                inParam={{
                                    defaultValues: currentValues ? currentValues : null
                                }}
                                isPopup={true}
                                isContextEditor={true}
                            />
                        </DialogContent>
                    </Dialog>
                )
            }
        </>
    )
};

export default OpenContextDesigner

OpenContextDesigner.propTypes = {
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    isOpen: PropTypes.bool,
    onSave: PropTypes.func,
    currentValues: PropTypes.object
};